/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import { reactive } from 'vue';
import { subscriptionOptions as obj } from '@/services/pproxies-price';
import { State } from '@/models/PremiumProxies';

export const state: State = reactive({
  selected: 'mixed',
  data: [],
  cards: [],
  info: [],
  value: 0,
});

export const data: any = [];

const price_version = 'pt4_2';
let price_version_url: any;

// don't touch
if (price_version) {
  price_version_url = `&price_version=${price_version}`;
} else {
  price_version_url = '';
}

export const getPrice = () => {
  const urls: string[] = [];
  state.cards.forEach((card: any) => {
    urls.push(card.url + price_version_url);
  });
  fetch('https://api.proxyscrape.com/v2/order/get_details.php', {
    method: 'POST',
    body: JSON.stringify(urls),
  })
    .then((res) => res.json())
    .then((d) => {
      d.forEach((price_data: any, i: number) => {
        state.cards[i].price = price_data.original_price;
      });
    });
};

export const getData = (country: null | string = null) => {
  // console.log(obj, 'obj');
  if (country) {
    const countryData = obj.filter((e) => e.information.abr === country)[0];
    state.selected = country;
    state.info = countryData.information;
    state.cards = countryData.cards;
    getPrice();
    return [];
  }
  return obj;
};
